import { useGetSaltoSpaceAccessPoints } from '@/api/keyless/salto-space/get-salto-space-access-points'

import { useGetSaltoSpaceConnection } from './get-salto-space-connection'

// Note: shared by every surface that needs to know whether a building's Salto Space
// integration is actually usable right now — Places → Integrations (the connection status
// pill) and the resident profile's Keyless Access tab (both designs), which used to trust a
// static `saltoSpaceAvailable` building flag with no live check at all. "Connected" requires
// both queries to succeed: `apiKey` alone only proves our DB has a value saved, while
// `access-points` is a live call to Salto Space's own API using that apiKey, so its failure
// means the vendor itself rejects it.
export const useIsSaltoSpaceBuildingConnected = (buildingId: number) => {
  const {
    data,
    isLoading: isLoadingConnection,
    isSuccess,
  } = useGetSaltoSpaceConnection({ buildingId })
  const { isLoading: isLoadingAccessPoints, isSuccess: isAccessPointsSuccess } =
    useGetSaltoSpaceAccessPoints({ buildingId })

  return {
    isBuildingConnected: isSuccess && isAccessPointsSuccess && Boolean(data?.apiKey),
    isLoading: isLoadingConnection || isLoadingAccessPoints,
  }
}
